import { Search, ScanBarcode } from "lucide-react";

interface ProductsSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  categoryFilter: string;
  onCategoryChange: (value: string) => void;
  categories: { id: number; name: string }[];
  inStockOnly: boolean;
  onInStockOnlyChange: (value: boolean) => void;
  onOpenScanner: () => void;
}

export default function ProductsSearch({
  searchQuery,
  onSearchChange,
  categoryFilter,
  onCategoryChange,
  categories,
  inStockOnly,
  onInStockOnlyChange,
  onOpenScanner,
}: ProductsSearchProps) {
  return (
    <div className="space-y-2">
      <div className="flex gap-2 items-center">
        <div className="relative flex-1 min-w-0">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground pointer-events-none" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Traži po nazivu ili SKU..."
            className="w-full rounded-lg border border-border bg-white pl-9 pr-3 py-2 text-sm h-9 focus:ring-1 focus:ring-foreground focus:border-foreground outline-none"
          />
        </div>
        <button
          type="button"
          onClick={onOpenScanner}
          className="size-9 shrink-0 rounded-lg border border-border bg-white hover:bg-neutral-50 flex items-center justify-center transition active:scale-95"
          title="Skeniraj barkod"
        >
          <ScanBarcode className="size-4 text-neutral-600" />
        </button>
        <select
          value={categoryFilter}
          onChange={(e) => onCategoryChange(e.target.value)}
          className="hidden md:block h-9 rounded-lg border border-border bg-white px-3 text-sm focus:ring-1 focus:ring-foreground focus:border-foreground outline-none shrink-0"
        >
          <option value="all">Sve kategorije</option>
          {categories.map((cat) => (
            <option key={cat.id} value={String(cat.id)}>{cat.name}</option>
          ))}
        </select>
      </div>
      <label className="flex items-center gap-2 text-sm text-neutral-700 select-none cursor-pointer w-fit">
        <input
          type="checkbox"
          checked={inStockOnly}
          onChange={(e) => onInStockOnlyChange(e.target.checked)}
          className="size-4 rounded border-border accent-foreground"
        />
        Samo na stanju
      </label>
      <select
        value={categoryFilter}
        onChange={(e) => onCategoryChange(e.target.value)}
        className="md:hidden w-full h-9 rounded-lg border border-border bg-white px-3 text-sm focus:ring-1 focus:ring-foreground focus:border-foreground outline-none"
      >
        <option value="all">Sve kategorije</option>
        {categories.map((cat) => (
          <option key={cat.id} value={String(cat.id)}>{cat.name}</option>
        ))}
      </select>
    </div>
  );
}
